import { useEffect, useState } from "react";

/**
 * Whether the element is on screen. Takes the element itself (from a callback
 * ref held in state) so it starts watching once a conditionally rendered
 * element mounts. Starts true, so something that only shows while the element
 * is out of view stays hidden until we know.
 */
export const useInView = (element: Element | null): boolean => {
  const [inView, setInView] = useState(true);
  useEffect(() => {
    if (!element || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) =>
      setInView(entry.isIntersecting),
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);
  return inView;
};
